/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as appRouteRouteImport } from './routes/(app)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PlaygroundStepperRouteImport } from './routes/playground/stepper'
import { Route as ConfirmationTokenRouteImport } from './routes/confirmation.$token'
import { Route as AuthVerificationRouteImport } from './routes/auth/verification'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthNewPasswordTokenRouteImport } from './routes/auth/new-password.$token'
import { Route as appTrackTrackidIndexRouteImport } from './routes/(app)/track/$trackid/index'
import { Route as appTrackTrackidSpeakingQuizidRouteImport } from './routes/(app)/track/$trackid/speaking.$quizid'
import { Route as appTrackTrackidQuizV2QuizidRouteImport } from './routes/(app)/track/$trackid/quiz-v2.$quizid'
import { Route as appTrackTrackidLessonLessonidRouteImport } from './routes/(app)/track/$trackid/lesson.$lessonid'
import { Route as appTrackTrackidExamExamidRouteImport } from './routes/(app)/track/$trackid/exam.$examid'

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundStepperRoute = PlaygroundStepperRouteImport.update({
  id: '/playground/stepper',
  path: '/playground/stepper',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmationTokenRoute = ConfirmationTokenRouteImport.update({
  id: '/confirmation/$token',
  path: '/confirmation/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerificationRoute = AuthVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthNewPasswordTokenRoute = AuthNewPasswordTokenRouteImport.update({
  id: '/new-password/$token',
  path: '/new-password/$token',
  getParentRoute: () => AuthRouteRoute,
} as any)
const appTrackTrackidIndexRoute = appTrackTrackidIndexRouteImport.update({
  id: '/track/$trackid/',
  path: '/track/$trackid/',
  getParentRoute: () => appRouteRoute,
} as any)
const appTrackTrackidSpeakingQuizidRoute =
  appTrackTrackidSpeakingQuizidRouteImport.update({
    id: '/track/$trackid/speaking/$quizid',
    path: '/track/$trackid/speaking/$quizid',
    getParentRoute: () => appRouteRoute,
  } as any)
const appTrackTrackidQuizV2QuizidRoute =
  appTrackTrackidQuizV2QuizidRouteImport.update({
    id: '/track/$trackid/quiz-v2/$quizid',
    path: '/track/$trackid/quiz-v2/$quizid',
    getParentRoute: () => appRouteRoute,
  } as any)
const appTrackTrackidLessonLessonidRoute =
  appTrackTrackidLessonLessonidRouteImport.update({
    id: '/track/$trackid/lesson/$lessonid',
    path: '/track/$trackid/lesson/$lessonid',
    getParentRoute: () => appRouteRoute,
  } as any)
const appTrackTrackidExamExamidRoute =
  appTrackTrackidExamExamidRouteImport.update({
    id: '/track/$trackid/exam/$examid',
    path: '/track/$trackid/exam/$examid',
    getParentRoute: () => appRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof appRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verification': typeof AuthVerificationRoute
  '/confirmation/$token': typeof ConfirmationTokenRoute
  '/playground/stepper': typeof PlaygroundStepperRoute
  '/auth/new-password/$token': typeof AuthNewPasswordTokenRoute
  '/track/$trackid': typeof appTrackTrackidIndexRoute
  '/track/$trackid/exam/$examid': typeof appTrackTrackidExamExamidRoute
  '/track/$trackid/lesson/$lessonid': typeof appTrackTrackidLessonLessonidRoute
  '/track/$trackid/quiz-v2/$quizid': typeof appTrackTrackidQuizV2QuizidRoute
  '/track/$trackid/speaking/$quizid': typeof appTrackTrackidSpeakingQuizidRoute
}
export interface FileRoutesByTo {
  '/': typeof appRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verification': typeof AuthVerificationRoute
  '/confirmation/$token': typeof ConfirmationTokenRoute
  '/playground/stepper': typeof PlaygroundStepperRoute
  '/auth/new-password/$token': typeof AuthNewPasswordTokenRoute
  '/track/$trackid': typeof appTrackTrackidIndexRoute
  '/track/$trackid/exam/$examid': typeof appTrackTrackidExamExamidRoute
  '/track/$trackid/lesson/$lessonid': typeof appTrackTrackidLessonLessonidRoute
  '/track/$trackid/quiz-v2/$quizid': typeof appTrackTrackidQuizV2QuizidRoute
  '/track/$trackid/speaking/$quizid': typeof appTrackTrackidSpeakingQuizidRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(app)': typeof appRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verification': typeof AuthVerificationRoute
  '/confirmation/$token': typeof ConfirmationTokenRoute
  '/playground/stepper': typeof PlaygroundStepperRoute
  '/auth/new-password/$token': typeof AuthNewPasswordTokenRoute
  '/(app)/track/$trackid/': typeof appTrackTrackidIndexRoute
  '/(app)/track/$trackid/exam/$examid': typeof appTrackTrackidExamExamidRoute
  '/(app)/track/$trackid/lesson/$lessonid': typeof appTrackTrackidLessonLessonidRoute
  '/(app)/track/$trackid/quiz-v2/$quizid': typeof appTrackTrackidQuizV2QuizidRoute
  '/(app)/track/$trackid/speaking/$quizid': typeof appTrackTrackidSpeakingQuizidRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verification'
    | '/confirmation/$token'
    | '/playground/stepper'
    | '/auth/new-password/$token'
    | '/track/$trackid'
    | '/track/$trackid/exam/$examid'
    | '/track/$trackid/lesson/$lessonid'
    | '/track/$trackid/quiz-v2/$quizid'
    | '/track/$trackid/speaking/$quizid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verification'
    | '/confirmation/$token'
    | '/playground/stepper'
    | '/auth/new-password/$token'
    | '/track/$trackid'
    | '/track/$trackid/exam/$examid'
    | '/track/$trackid/lesson/$lessonid'
    | '/track/$trackid/quiz-v2/$quizid'
    | '/track/$trackid/speaking/$quizid'
  id:
    | '__root__'
    | '/'
    | '/(app)'
    | '/auth'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verification'
    | '/confirmation/$token'
    | '/playground/stepper'
    | '/auth/new-password/$token'
    | '/(app)/track/$trackid/'
    | '/(app)/track/$trackid/exam/$examid'
    | '/(app)/track/$trackid/lesson/$lessonid'
    | '/(app)/track/$trackid/quiz-v2/$quizid'
    | '/(app)/track/$trackid/speaking/$quizid'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  appRouteRoute: typeof appRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  ConfirmationTokenRoute: typeof ConfirmationTokenRoute
  PlaygroundStepperRoute: typeof PlaygroundStepperRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)': {
      id: '/(app)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground/stepper': {
      id: '/playground/stepper'
      path: '/playground/stepper'
      fullPath: '/playground/stepper'
      preLoaderRoute: typeof PlaygroundStepperRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirmation/$token': {
      id: '/confirmation/$token'
      path: '/confirmation/$token'
      fullPath: '/confirmation/$token'
      preLoaderRoute: typeof ConfirmationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verification': {
      id: '/auth/verification'
      path: '/verification'
      fullPath: '/auth/verification'
      preLoaderRoute: typeof AuthVerificationRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/new-password/$token': {
      id: '/auth/new-password/$token'
      path: '/new-password/$token'
      fullPath: '/auth/new-password/$token'
      preLoaderRoute: typeof AuthNewPasswordTokenRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/(app)/track/$trackid/': {
      id: '/(app)/track/$trackid/'
      path: '/track/$trackid'
      fullPath: '/track/$trackid'
      preLoaderRoute: typeof appTrackTrackidIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/track/$trackid/speaking/$quizid': {
      id: '/(app)/track/$trackid/speaking/$quizid'
      path: '/track/$trackid/speaking/$quizid'
      fullPath: '/track/$trackid/speaking/$quizid'
      preLoaderRoute: typeof appTrackTrackidSpeakingQuizidRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/track/$trackid/quiz-v2/$quizid': {
      id: '/(app)/track/$trackid/quiz-v2/$quizid'
      path: '/track/$trackid/quiz-v2/$quizid'
      fullPath: '/track/$trackid/quiz-v2/$quizid'
      preLoaderRoute: typeof appTrackTrackidQuizV2QuizidRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/track/$trackid/lesson/$lessonid': {
      id: '/(app)/track/$trackid/lesson/$lessonid'
      path: '/track/$trackid/lesson/$lessonid'
      fullPath: '/track/$trackid/lesson/$lessonid'
      preLoaderRoute: typeof appTrackTrackidLessonLessonidRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/track/$trackid/exam/$examid': {
      id: '/(app)/track/$trackid/exam/$examid'
      path: '/track/$trackid/exam/$examid'
      fullPath: '/track/$trackid/exam/$examid'
      preLoaderRoute: typeof appTrackTrackidExamExamidRouteImport
      parentRoute: typeof appRouteRoute
    }
  }
}

interface appRouteRouteChildren {
  appTrackTrackidIndexRoute: typeof appTrackTrackidIndexRoute
  appTrackTrackidExamExamidRoute: typeof appTrackTrackidExamExamidRoute
  appTrackTrackidLessonLessonidRoute: typeof appTrackTrackidLessonLessonidRoute
  appTrackTrackidQuizV2QuizidRoute: typeof appTrackTrackidQuizV2QuizidRoute
  appTrackTrackidSpeakingQuizidRoute: typeof appTrackTrackidSpeakingQuizidRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appTrackTrackidIndexRoute: appTrackTrackidIndexRoute,
  appTrackTrackidExamExamidRoute: appTrackTrackidExamExamidRoute,
  appTrackTrackidLessonLessonidRoute: appTrackTrackidLessonLessonidRoute,
  appTrackTrackidQuizV2QuizidRoute: appTrackTrackidQuizV2QuizidRoute,
  appTrackTrackidSpeakingQuizidRoute: appTrackTrackidSpeakingQuizidRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerificationRoute: typeof AuthVerificationRoute
  AuthNewPasswordTokenRoute: typeof AuthNewPasswordTokenRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerificationRoute: AuthVerificationRoute,
  AuthNewPasswordTokenRoute: AuthNewPasswordTokenRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  appRouteRoute: appRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  ConfirmationTokenRoute: ConfirmationTokenRoute,
  PlaygroundStepperRoute: PlaygroundStepperRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
